import React from 'react';
import { Link } from 'react-router-dom';
import { useCursor } from '../context/CursorContext';
import { AnimatedSection, StaggerChildren } from '../components/AnimatedSection';
import { TiltCard } from '../components/TiltCard';
import { socialPlatforms } from '../data/mock';

export default function CommunityPage() {
  const { setLabel } = useCursor();

  return (
    <div className="min-h-screen pt-32 pb-20 px-6">
      <div className="max-w-5xl mx-auto">
        <AnimatedSection className="text-center mb-16">
          <p className="text-green-500 font-semibold uppercase tracking-[0.3em] mb-3 text-xs">
            Join
          </p>
          <h1 className="text-4xl md:text-5xl font-black text-white mb-3">
            THE COMMUNITY
          </h1>
          <p className="text-white/40">Connect with like-minded individuals</p>
          <div className="mt-4 mx-auto w-16 h-px bg-gradient-to-r from-transparent via-green-500 to-transparent" />
        </AnimatedSection>

        <StaggerChildren className="grid md:grid-cols-2 gap-4" staggerDelay={150}>
          {socialPlatforms.map((social) => (
            <a
              key={social.platform}
              href={social.url}
              target={social.url !== '#' ? '_blank' : undefined}
              rel={social.url !== '#' ? 'noopener noreferrer' : undefined}
            >
              <TiltCard
                cursorLabel="Join"
                className="group p-6 border border-white/5 bg-white/[0.02] hover:border-green-500/30"
              >
                <div className="flex items-center gap-5">
                  <div className="w-14 h-14 bg-green-500 flex items-center justify-center shrink-0">
                    <span className="text-black font-black text-lg">
                      {social.abbr}
                    </span>
                  </div>
                  <div className="flex-1">
                    <p className="text-lg font-black text-white">
                      {social.platform}
                    </p>
                    <p className="text-green-500 font-bold">{social.members}</p>
                  </div>
                  <span className="text-white/20 text-xl group-hover:text-green-500 group-hover:translate-x-1 transition-all duration-300">
                    &rarr;
                  </span>
                </div>
              </TiltCard>
            </a>
          ))}
        </StaggerChildren>

        {/* Alpha Group */}
        <AnimatedSection delay={300} className="mt-12">
          <div className="p-10 border border-green-500/20 bg-green-500/5 text-center relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-green-500/5 via-transparent to-emerald-500/5 animate-gradient" />
            <div className="relative z-10">
              <h2 className="text-2xl font-black text-white mb-2">ALPHA GROUP</h2>
              <p className="text-white/50 mb-6 text-sm">
                Exclusive trading signals & direct creator access.
              </p>
              <Link
                to="/join"
                className="group relative inline-block px-8 py-4 bg-green-500 text-black font-bold uppercase tracking-wider text-sm hover:bg-green-400 transition-colors duration-300 overflow-hidden"
                onMouseEnter={() => setLabel('Apply')}
                onMouseLeave={() => setLabel('')}
              >
                <span className="relative z-10">Apply for Access</span>
                <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-emerald-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </Link>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </div>
  );
}
